import axios from "axios";
import { mockCars, mockCarDetails } from "../data/mockCars";

const API_URL = process.env.REACT_APP_API_URL;

// Si no hay API configurada, trabajamos directo con los datos de ejemplo
const USE_MOCKS = !API_URL;

function filterAndSortMocks(segment, order) {
  let result = [...mockCars];

  if (segment) {
    result = result.filter((c) => c.segment === segment);
  }

  switch (order) {
    case "precio-asc":
      result.sort((a, b) => a.price - b.price);
      break;
    case "precio-desc":
      result.sort((a, b) => b.price - a.price);
      break;
    case "nuevos":
      result.sort((a, b) => b.year - a.year);
      break;
    case "viejos":
      result.sort((a, b) => a.year - b.year);
      break;
    default:
      break;
  }

  return result;
}

export const fetchCars = async (segment, order, id) => {
  // Sin API configurada → devolvemos directamente los mocks
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 200)); // simula latencia mínima
    return filterAndSortMocks(segment, order);
  }

  try {
    const params = new URLSearchParams();

    if (segment) params.append("segment", segment);

    if (order) {
      switch (order) {
        case "precio-asc":
          params.append("ordering", "price");
          break;
        case "precio-desc":
          params.append("ordering", "-price");
          break;
        case "nuevos":
          params.append("ordering", "-year");
          break;
        case "viejos":
          params.append("ordering", "year");
          break;
        default:
          console.warn("Criterio de orden no válido.");
          break;
      }
    }

    const url = id ? `${API_URL}${id}/` : API_URL;
    const response = await axios.get(url, { params });

    return response.data;
  } catch (error) {
    console.warn("No se pudo conectar a la API, usando datos de ejemplo.", error.message);
    return filterAndSortMocks(segment, order);
  }
};

// Función para obtener los detalles de un solo auto
export const fetchCarDetails = async (id) => {
  if (USE_MOCKS) {
    await new Promise((r) => setTimeout(r, 150));
    return mockCarDetails[id] || null;
  }

  try {
    const url = `${API_URL}${id}/`;
    const response = await axios.get(url);

    return response.data;
  } catch (error) {
    console.warn("No se pudo conectar a la API, usando datos de ejemplo.", error.message);
    return mockCarDetails[id] || null;
  }
};
